'use client';

import clsx from 'clsx';
import { useEffect, useReducer, useState } from 'react';

type State = {
  leftInitialViewport: boolean;
  hasScrolledUp: boolean;
  elementInView: boolean;
};

const useScrollDirection = () => {
  const [scrollDirection, setScrollDirection] = useState('');
  const [prevOffset, setPrevOffset] = useState(0);
  const [state, dispatch] = useReducer(
    (state: State, action: Partial<State>) => ({
      ...state,
      ...action,
    }),
    { leftInitialViewport: false, hasScrolledUp: false, elementInView: true },
  );

  const toggleScrollDirection = () => {
    const ELEMENT_HEIGHT = 200;
    const VIEWPORT_HEIGHT = document?.querySelector('html')?.clientHeight || 50;
    const scrollY = window.scrollY;
    dispatch({
      leftInitialViewport: scrollY >= VIEWPORT_HEIGHT,
      elementInView: scrollY < ELEMENT_HEIGHT,
      hasScrolledUp: scrollY >= VIEWPORT_HEIGHT && state.hasScrolledUp,
    });

    if (scrollY > prevOffset) {
      setScrollDirection('down');
    } else if (scrollY < prevOffset) {
      setScrollDirection('up');
      dispatch({ hasScrolledUp: true });
    } else {
      setScrollDirection('');
    }
    setPrevOffset(scrollY);
  };
  useEffect(() => {
    window.addEventListener('scroll', toggleScrollDirection);
    return () => {
      window.removeEventListener('scroll', toggleScrollDirection);
    };
  });
  return {
    up: scrollDirection === 'up' && state.leftInitialViewport,
    down: scrollDirection === 'down' && state.leftInitialViewport,
    active: state.leftInitialViewport,
    animated: state.hasScrolledUp,
    faded: !state.elementInView && !state.leftInitialViewport,
  };
};

function ScrollDetector() {
  const { up, down, active, animated, faded } = useScrollDirection();

  return (
    <div
      aria-hidden='true'
      className={clsx('scroll-detector', {
        up,
        down,
        active,
        animated,
        faded,
      })}
    ></div>
  );
}

export default ScrollDetector;
